<template>
  <div>
    <div class="cert-header d-flex py-4">
      <div class="col-12 col-md-11 col-lg-10 px-3 p-md-0 mx-auto">
        <div class="cert-title cert-large mt-3 mt-xl-0">Contact Us</div>
      </div>
    </div>
    <div class="col-12 col-md-11 col-lg-10 col-xl-7 cert-announcement my-4 mx-auto p-3">In case you are unable to get
      specific information or you have a
      request,
      contact us directly using <strong>info@ncsa.gov.rw</strong> or call us on our toll free number <strong>9009 or 0781813310</strong>.
      <br/>
      For international calls, dial or send a whatsapp message to <strong>+250 734 440 852</strong>.
    </div>
    <div class="col-12 col-md-11 col-lg-10 col-xl-7 p-2 p-sm-5 mx-auto mt-2 mt-sm-3 cert-page-content row">
      <div class="col-12 mt-5 mt-xl-0">
        <form role="form">
          <argon-alert class="alert-success alert-dismissible" v-if="responseSuccess">
            Submitted Successfully
          </argon-alert>
          <argon-alert class="alert-danger alert-dismissible" v-if="responseError">
            Something went wrong
          </argon-alert>
          <div class="mb-3">
            <label>Name<span style='color:red'>*</span></label>
            <input type="text" class="form-control" placeholder="Your name" name="name" v-model="name"/>
            <div class="validation-error" v-if="!validation.name.status" style="color: red">{{ validation.name.message }}</div>
          </div>
          <div class="mb-3">
            <label>Email address<span style='color:red'>*</span></label>
            <input type="email" class="form-control" placeholder="Your email address" id="email" v-model="email"
            >
            <div class="validation-error" v-if="!validation.email.status" style="color: red">{{ validation.email.message }}</div>
          </div>
          <div class="mb-3">
            <label>Location<span style='color:red'>*</span></label>
            <input type="text" class="form-control" placeholder="City, Country" name="location" v-model="location">
            <div class="validation-error" v-if="!validation.location.status" style="color: red">{{ validation.location.message }}</div>
          </div>
          <div class="mb-3">
            <label>Subject<span style='color:red'>*</span></label>
            <input type="text" class="form-control" placeholder="Subject" name="subject" v-model="subject">
            <div class="validation-error" v-if="!validation.subject.status" style="color: red">{{ validation.subject.message }}</div>
          </div>
          <div class="mb-3">
            <label>Message<span style='color:red'>*</span> </label>
            <textarea placeholder="Detailed message" class="form-control" id="message" name="message"
                      v-model="message"></textarea>
            <div class="validation-error" v-if="!validation.message.status" style="color: red">{{ validation.message.message }}</div>
          </div>
          <div class="text-center">
            <argon-button
                class="mt-4"
                variant="gradient"
                fullWidth
                color="primary"
                type="button"
                :disabled="disableSubmit"
                @click="addContact">Send
            </argon-button>
          </div>

        </form>
      </div>
    </div>
  </div>
</template>
<style scoped>
.validation-error{
  font-size: 14.5px;
}
</style>
<script>
import ArgonButton from "@/components/ArgonButton";
import ArgonAlert from "@/components/ArgonAlert";
import axios from "axios";
import validators from "@/assets/helper/validators";
export default {
  name: "Home",
  props: {
    cardBg: String
  },
  data: function () {
    return {
      name: "",
      email: "",
      subject: "",
      location: "",
      message: "",
      responseSuccess: false,
      responseError: false,
      reCaptchaResponse: false,
      reCaptchaError: false,
      disableSubmit: false,
      validation: {
        name: {status: true, message: null},
        email: {status: true, message: null},
        subject: {status: true, message: null},
        location: {status: true, message: null},
        message: {status: true, message: null}
      }
    };
  },
  components: {
    ArgonAlert,
    ArgonButton,
  },
  methods: {
    verifyMethod() {
      this.reCaptchaResponse = true;
      this.reCaptchaError = false;
    },
    expiredMethod() {
      this.reCaptchaResponse = false;
    },
    errorMethod() {
      this.reCaptchaResponse = false;
    },
    contactValidationStatus() {
      this.validation.name = validators.validateText("name", this.name.trim());
      this.validation.location = this.location.trim() === '' ? {
        message: "Country and city should not be empty",
        status: false
      } : {message: "Valid", status: true};
      this.validation.subject = this.subject.trim() === '' ? {
        message: "Subject should not be empty",
        status: false
      } : {message: "Valid", status: true};
      this.validation.message = this.message.trim() === '' ? {
        message: "Message should not be empty",
        status: false
      } : {message: "Valid", status: true};
      ;
      this.validation.email = validators.validateEmailAddress(this.email.trim());
      return this.validation.name.status && this.validation.location.status && this.validation.email.status && this.validation.message.status && this.validation.subject.status;
    },
    addContact() {
      const data = {
        name: this.name,
        email: this.email,
        location: this.location,
        subject: this.subject,
        message: this.message
      };
      if (this.contactValidationStatus()) {
        this.disableSubmit = true;
        axios.post(`${process.env.VUE_APP_BASE_URL}contact`, data)
            .then(() => {
              this.name = "";
              this.email = "";
              this.subject = "";
              this.location = "";
              this.message = "";
              this.responseSuccess = true;
              setTimeout(() => this.responseSuccess = !this.responseSuccess, 12000);
              this.disableSubmit = false;
            })
            .catch(error => {
              this.responseError = !this.responseError;
              setTimeout(() => this.responseError = !this.responseError, 12000);
              this.errorMessage = error.message;
              console.error("There was an error!", error);
              this.disableSubmit = false;
            });
      }
    }
  },
  created() {
  }
};
</script>